export default "__VITE_ASSET__CpyHk7Q___"